import React from "react";

export default function Devices() {
  const rows = Array.from({ length: 6 }, (_, i) => ({
    id: `dev-${i + 1}`,
    type: i % 2 ? "Lumina Vibe" : "Oura Gen3",
    lastSync: new Date(Date.now() - i * 3600_000).toLocaleString(),
    status: i % 3 === 0 ? "ok" : "attention",
  }));

  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
      <div className="text-base font-semibold mb-2">Org Devices</div>
      <div className="overflow-auto">
        <table className="w-full text-sm">
          <thead className="text-left opacity-70">
            <tr>
              <th className="py-2 pr-4">ID</th>
              <th className="py-2 pr-4">Type</th>
              <th className="py-2 pr-4">Last Sync</th>
              <th className="py-2 pr-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-white/10">
                <td className="py-2 pr-4 font-mono">{r.id}</td>
                <td className="py-2 pr-4">{r.type}</td>
                <td className="py-2 pr-4 text-xs opacity-80">{r.lastSync}</td>
                <td className="py-2 pr-4">
                  <span
                    className={`px-2 py-0.5 rounded-full text-[11px] border ${
                      r.status === "ok"
                        ? "bg-emerald-500/15 border-emerald-400/30"
                        : "bg-yellow-500/15 border-yellow-400/30"
                    }`}
                  >
                    {r.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-4 text-sm opacity-70">
        Wire to <span className="font-mono">/realms/{`{realm}`}/orgs/{`{org}`}/devices</span>.
      </div>
    </div>
  );
}
